var Handlebars = require("../../../../../node_modules/handlebars/runtime.js");
function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
module.exports = (Handlebars["default"] || Handlebars).template({"1":function(container,depth0,helpers,partials,data) {
    return "grepMode";
},"3":function(container,depth0,helpers,partials,data) {
    return "hideHits";
},"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, alias1=depth0 != null ? depth0 : (container.nullContext || {});

  return "<div id=\"esHeader\" data-region=\"true\"></div>\n    <div class=\"esContentWr "
    + ((stack1 = helpers["if"].call(alias1,(depth0 != null ? depth0.grepMode : depth0),{"name":"if","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
    + " "
    + ((stack1 = helpers["if"].call(alias1,(depth0 != null ? depth0.hideHits : depth0),{"name":"if","hash":{},"fn":container.program(3, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
    + "\" >\n        <div class=\"esContentInnerWr\" data-region=\"true\" data-scroller=\"true\"></div>\n    </div>\n<div id=\"esFooter\" data-region=\"true\" ></div>\n\n";
},"useData":true});


/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/modules/fulltext/layout/template.hbs
 ** module id = 555
 ** module chunks = 0
 **/